import {number, array, record, oneOf, Parser, date} from '@freckle/parser'

// TODO: Centralize license subjects by grepping on social_studies
export type LicenseAllocationSubjectT = 'math' | 'ela' | 'social_studies' | 'science'

export type TeacherLicenseAllocationT = {
  id: number
  subject: LicenseAllocationSubjectT
  startsAt: Date
  expiresAt: Date
}

export type TeacherLicenseAllocationPostT = {
  subject: LicenseAllocationSubjectT
  startsAt: Date
  expiresAt: Date
}

const parseLicenseAllocation = record({
  id: number(),
  subject: oneOf<LicenseAllocationSubjectT>('LicenseAllocationSubjectT', [
    'math',
    'ela',
    'social_studies',
    'science'
  ]),
  startsAt: date(),
  expiresAt: date()
})

export const parseLicenses = (response: Array<unknown>): Array<TeacherLicenseAllocationT> =>
  Parser.run(response, array(parseLicenseAllocation)) as TeacherLicenseAllocationT[]
